import http from "@/services/http";
import { useAuth } from "@/services/auth.js";

export const plans = () => {
  const auth = useAuth();

  async function list() {
    try {
      const { data } = await http.get('/admin/plans', auth.getBearer());
      return data;
    } catch (error) {
      console.log(error?.response?.data);
      return [];
    }
  }

  async function create(payload) {
    try {
      const { data } = await http.post('/admin/plans', payload, auth.getBearer());
      return data.data;
    } catch (error) {
      throw error?.response?.data ?? error;
    }
  }

  async function update(id, payload) {
    try {
      const { data } = await http.put(`/admin/plans/${id}`, payload, auth.getBearer());
      return data.data;
    } catch (error) {
      throw error?.response?.data ?? error;
    }
  }

  async function remove(id) {
    try {
      await http.delete(`/admin/plans/${id}`, auth.getBearer());
      return true;
    } catch (error) {
      throw error?.response?.data ?? error;
    }
  }

  return { list, create, update, remove }
}
